import { PhoneCall, MessagesSquare, MonitorCheck, BookOpen, Users, ShieldCheck } from "lucide-react";
import { Reveal, Overline } from "./Reveal";

const ITEMS = [
  {
    icon: PhoneCall,
    title: "Onboarding call — 45 minutes, one-to-one",
    body: "We map your six months, set your checkpoint dates, and confirm your setup before you start.",
    span: "md:col-span-5",
  },
  {
    icon: MessagesSquare,
    title: "Daily support, Monday to Friday",
    body: "Direct message access to our team in your private client channel. One business day response, business hours. This is where the real work happens.",
    span: "md:col-span-7",
  },
  {
    icon: MonitorCheck,
    title: "Four one-to-one checkpoint reviews",
    body: "Live screen-share sessions at the four stages that matter most: Seller Central approval, product validation, supplier outreach, and your first purchase order.",
    span: "md:col-span-4",
  },
  {
    icon: BookOpen,
    title: "Complete written playbooks",
    body: "Step-by-step SOPs, templates, and scripts for every stage: entity and EIN, Seller Central application, product research criteria, brand and supplier outreach, listing and pricing, order flow, account health.",
    span: "md:col-span-4",
  },
  {
    icon: Users,
    title: "Monthly group session",
    body: "Optional and recorded. Market updates, policy changes, and open Q&A with the team.",
    span: "md:col-span-4",
  },
  {
    icon: ShieldCheck,
    title: "Our commitment",
    body: "Complete every checkpoint and if you haven't reached $10,000 in gross Amazon sales in six months, we keep working with you at no additional cost until you do.",
    span: "md:col-span-12",
    accent: true,
  },
];

export function IncludedStack() {
  return (
    <section data-testid="included-section" className="border-t border-black/10 bg-white">
      <div className="mx-auto max-w-[1600px] px-5 py-32 md:px-10 md:py-48">
        <Reveal className="flex flex-wrap items-end justify-between gap-6">
          <div>
            <Overline>What's included</Overline>
            <h2 className="mt-6 font-display text-4xl font-black tracking-tighter sm:text-5xl lg:text-6xl">
              Six months. Every stage,{" "}
              <span className="text-signal">mapped.</span>
            </h2>
          </div>
          <p className="max-w-sm font-body text-sm text-ink/50">
            We charge $25,000 to build your Amazon business for you. This year,
            we teach 10 people to build their own — with our operators beside
            them.
          </p>
        </Reveal>

        <div className="mt-20 grid grid-cols-1 gap-px bg-black/10 md:grid-cols-12">
          {ITEMS.map((item, i) => (
            <Reveal key={item.title} delay={i * 0.08} className={`${item.span} bg-[#F4F2EC]`}>
              <article
                data-testid={`included-card-${i}`}
                className={`group flex h-full flex-col p-8 transition-colors duration-300 md:p-12 ${
                  item.accent
                    ? "bg-signal text-white md:flex-row md:items-center md:gap-12"
                    : "hover:bg-white"
                }`}
              >
                <item.icon
                  className={`h-7 w-7 ${item.accent ? "text-white" : "text-signal"}`}
                  strokeWidth={1.5}
                />
                <div className={item.accent ? "" : "mt-10"}>
                  <h3 className="font-display text-2xl font-bold tracking-tight">
                    {item.title}
                  </h3>
                  <p
                    className={`mt-3 max-w-2xl font-body text-sm leading-relaxed ${
                      item.accent ? "text-white/85" : "text-ink/60"
                    }`}
                  >
                    {item.body}
                  </p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
